import type { ApiReturnMeasureType } from '@highimpact-frontend/api-types';
import { useQuery } from '@tanstack/react-query';

import { useDashboardHost } from '../context/DashboardHostContext';
import { dashboardQueryKeys } from './queryKeys';

export interface UseMeasureTypesQueryResult {
  readonly measureTypes: readonly ApiReturnMeasureType[];
  readonly loading: boolean;
  readonly error: boolean;
}

/** Loads the global measure-type catalog via {@link DashboardHostApi.measureTypes}. */
export function useMeasureTypesQuery(): UseMeasureTypesQueryResult {
  const host = useDashboardHost();

  const query = useQuery({
    queryKey: dashboardQueryKeys.measureTypes(),
    queryFn: () => host.api.measureTypes.getAll(),
    staleTime: 300_000,
  });

  return {
    measureTypes: query.data ?? [],
    loading: query.isPending,
    error: query.isError,
  };
}
